export default {
  'title': 'Miam !',
  'conditions-title': 'Conditions de l’offre',
  'VALUE_plural': 'Vous avez gagné une réduction de %{amount} euros !',
  'VALUE': 'Vous avez gagné une réduction de %{amount} euro !',
  'PERCENT': 'Vous avez gagné une réduction de %{percent}% sur votre panier !',
  'FREE_SHIPPING': 'Vous avez gagné des frais de livraison offerts !',
  'FREE_ARTICLE': 'Vous avez gagné un produit offert !',
};
